import React, { MouseEvent } from 'react';

import {
  Pagination as MuiPagination,
  TablePaginationProps,
} from '@mui/material';
import {
  gridFilteredTopLevelRowCountSelector,
  gridPageSizeSelector,
  GridPagination,
  useGridApiContext,
  useGridRootProps,
  useGridSelector,
} from '@mui/x-data-grid';

import { IObject } from '../../interfaces/IObject';

interface Props
  extends Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'> {}

const getPageCount = (rowCount: number, pageSize: number): number => {
  if (pageSize > 0 && rowCount > 0) {
    return Math.ceil(rowCount / pageSize);
  }

  return 0;
};

function Pagination({ page, onPageChange, className }: Props) {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();

  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const visibleTopLevelRowCount = useGridSelector(
    apiRef,
    gridFilteredTopLevelRowCountSelector
  );
  const pageCount = getPageCount(
    rootProps.rowCount ?? visibleTopLevelRowCount,
    pageSize
  );

  return (
    <MuiPagination
      color="primary"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event as MouseEvent<HTMLButtonElement>, newPage - 1);
      }}
    />
  );
}

function CustomPagination(props: IObject) {
  return <GridPagination ActionsComponent={Pagination} {...props} />;
}

export default CustomPagination;
